import { formatInTimeZone } from 'date-fns-tz';
import addDays from 'date-fns/addDays';
import type {
	ReleaseNode,
	ValidReleaseNode,
} from '@atlassian/jira-shared-software-dates/src/controllers/use-fetch-releases/types';
import type { FullCalendarItemInput } from '../../types';

const isValidRelease = (node: ReleaseNode): node is ValidReleaseNode => node?.releaseDate != null;

export const transformData = (releases: ReleaseNode[]): FullCalendarItemInput[] =>
	releases.filter(isValidRelease).map((release): FullCalendarItemInput => {
		const endDate = addDays(new Date(release.releaseDate), 1);
		return {
			allDay: true,
			title: release.name,
			start: formatInTimeZone(release.releaseDate, 'UTC', 'yyyy-MM-dd'),
			end: formatInTimeZone(endDate, 'UTC', 'yyyy-MM-dd'),
			editable: false,
			extendedProps: { release },
		};
	});
